import type { Dispatch } from 'react';
import { sendChannelTemplate } from 'src/modules/conversations/api';
import { UPSERT_WARBOX_MESSAGE } from '../constants/actions';
import type { TWarboxMessageActionTypes } from '../types';

const ERROR_CANNOT_SEND_TEMPLATE = 'Errors.CannotSendWsp';

type SendTemplatePayload = {
    conversationId: string;
    storeId: string;
    area: string;
    _id?: string;
    senderPhone?: string;
    recipientPhone?: string;
    to?: string | null;
    from?: string | null;
    phone?: string;
    body?: string;
    message?: string;
    templateTitle?: string;
    templateType?: string;
    messageWithoutFormat?: string;
    options?: Record<string, unknown>;
    contentSid?: string;
    contentTemplateBuilder?: {
        contentSid?: string;
        contentVariablesType?: string;
    };
    language?: string;
    by?: {
        name?: string;
        id?: string;
    };
};

const getRecipientPhone = (payload: SendTemplatePayload) =>
    payload.recipientPhone || payload.to || payload.phone || '';

const getMessage = (payload: SendTemplatePayload) =>
    payload.body || payload.message || '';

export const sendTemplateMessage = async (
    dispatch: Dispatch<TWarboxMessageActionTypes>,
    payload: SendTemplatePayload
): Promise<void> => {
    const recipientPhone = getRecipientPhone(payload);
    const message = getMessage(payload);

    if (!recipientPhone || !message || !payload.templateTitle) {
        throw new Error(ERROR_CANNOT_SEND_TEMPLATE);
    }

    const result = await sendChannelTemplate({
        conversationId: payload.conversationId,
        storeId: payload.storeId,
        area: payload.area,
        _id: payload._id,
        senderPhone: payload.senderPhone || payload.from || undefined,
        recipientPhone,
        message,
        body: payload.body,
        templateTitle: payload.templateTitle,
        templateType: payload.templateType,
        messageWithoutFormat: payload.messageWithoutFormat,
        options: payload.options,
        contentSid:
            payload.contentSid || payload.contentTemplateBuilder?.contentSid,
        contentTemplateBuilder: payload.contentTemplateBuilder,
        language: payload.language,
        by: payload.by,
        author: payload.by?.name,
    });

    if (result?.message) {
        dispatch({
            type: UPSERT_WARBOX_MESSAGE,
            payload: result.message,
        });
    }
};
